import { Language } from "store/slices/language-slice";

interface UpdatePasswordMessages {
  title: string;
  description: string;
  keywords: string;
}

type Message = {
  [key in Language]: UpdatePasswordMessages;
};

const messages: Message = {
  en: {
    description: '',
    keywords: '',
    title: '',
  },
};

export default messages;
